import React, { useEffect, useState } from 'react'
import { useParams, useLocation, Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import RenderSubRoutes from 'components/RenderSubRoutes'
import SidebarProjectTop from '../../components/Sidebars/SidebarProjectTop'
import SidebarLocationProjectRecent from '../../components/Sidebars/SidebarLocationProjectRecent'
import SidebarLocationProjectPartners from '../../components/Sidebars/SidebarLocationProjectPartners'
import getProjectRoutes from './getRoutes/getProjectRoutes'
import Layout from 'components/Layout'
import { BusinessCard } from 'components/Card'
import routes from 'constants/routes'
import useMediaQuery from 'hooks/useMediaQuery'
import * as _ from 'styles/helpers'
import { getLocationByID, initializeActiveLocations } from 'slices/locationSlice'
import { initializeUsers } from 'slices/usersSlice'
import { initializeMyProjects } from 'slices/projectSlice'

const Projects_Show = () => {
	const dispatch = useDispatch()
	const params = useParams()
	const { id } = params

	const [backTitle, setBackTitle] = useState(null)
	const [backLink, setBackLink] = useState(null)

	const currentRoute = useLocation()

	const getBackLink = () => {
		if (currentRoute.state) {
			if (backTitle === null) {
				setBackTitle(currentRoute.state.backButtonTitle)
				setBackLink(currentRoute.state.backButtonLink)
			}
			return { title: currentRoute.state.backButtonTitle, link: currentRoute.state.backButtonLink }
		}
		if (backTitle !== null) {
			return { title: backTitle, link: backLink }
		}
		return { title: 'Projects', link: routes.PROJECTS }
	}

	const pathArray = currentRoute.pathname.split('/')
	const isPartnerPage = pathArray[pathArray.length - 1] === 'partners'

	const userLogin = useSelector(state => state.userLogin)
	const { userInfo } = userLogin

	const { projectLoading, projectInitialized, project } = useSelector(state => {
		return {
			projectLoading: state.projects.isLoading,
			projectInitialized: state.projects.isInitialized,
			project: state.projects.entities[id],
		}
	})

	const locationId = project?.projectAsset?._id || id
	const { isLoading, isInitialized, location } = useSelector(state => {
		return {
			isLoading: state.locations.isLoading,
			isInitialized: state.locations.isInitialized,
			location: state.locations.entities[locationId],
		}
	})

	const { success: userListInitialized } = useSelector(state => {
		return {
			success: state.userList.isInitialized,
		}
	})

	useEffect(() => {
		// if (!isInitialized) {
		dispatch(initializeActiveLocations())
		// }
		if (!userListInitialized) {
			dispatch(initializeUsers())
		}
		dispatch(initializeMyProjects())
	}, [dispatch, id, isInitialized, projectInitialized, userListInitialized])

	const partners = project?.partners
	const assetOwner = project?.owner
	const isMobile = useMediaQuery(_.MQ.before_nav)

	if (!project) {
		return null
	}

	const subRoutes = getProjectRoutes(id)

	return (
		<Layout>
			{/* <Layout.SecondaryNav links={subRoutes} backLink={getBackLink()} /> */}
			<Layout.SecondaryNav
				links={subRoutes}
				backLink={getBackLink()}
				sourceId={null}
				sourceName="Projects"
			/>
			<Layout.Page>
				<Layout.Sidebar isOffset>
					{project && (
						<>
							<SidebarProjectTop
								location={location ? location : null}
								project={project ? project : null}
								originator={`Project Originator:  `}
							/>
							<SidebarLocationProjectRecent project={project} />
							<SidebarLocationProjectPartners
								location={location}
								project={project ? project : null}
								assetOwner={assetOwner}
								assetName={location?.assetName}
								projectPartners={partners}
								userId={userInfo._id}
							/>
						</>
					)}
				</Layout.Sidebar>
				<Layout.Body>
					<RenderSubRoutes routes={subRoutes} state={currentRoute.state} />
				</Layout.Body>
			</Layout.Page>
		</Layout>
	)
}

export default Projects_Show
